module.exports = __webpack_public_path__ + "static/media/logoevflow.126f8e6d.png";